import { useState } from "react";
import moment from "moment";

import { Grid2, Stack, Typography } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import { approvedFrequency } from "../services/students";

// import DateRanger from "./DateRanger";
import { Empty } from "./Empty";
import Loading from "./Loading";
import CalendarComponent from "./CalendarComponent";

const ClassesFrequency = ({ studentId }: { studentId: number }) => {
  const [currentDate, setCurrentDate] = useState(moment().toDate());
  const [startTime, setStartTime] = useState(
    moment().startOf("month").toDate()
  );
  const [endTime, setEndTime] = useState(moment().endOf("month").toDate());

  const {
    data: dataClasses,
    isLoading: isLoadingClasses,
    isFetching: isFetchingClasses,
  }: {
    data: { frequency: []; totalFrequency: number; totalFrequencyAll: number };
    isLoading: boolean;
    isFetching: boolean;
  } = useQuery({
    queryKey: ["approvedFrequency" + studentId + startTime],
    queryFn: async () =>
      await approvedFrequency({
        startDate: startTime,
        endDate: endTime,
        studentId,
      }),
    initialData: { frequency: [], totalFrequency: 0, totalFrequencyAll: 0 },
  });

  const dates = dataClasses?.frequency?.map((i: any) => i.classes.date);
  const uniqueSortedDates = [...new Set(dates)]
    .map((date) => moment(date))
    .sort((a: any, b: any) => a - b)
    .map((date) => date.toISOString());

  return (
    <Grid2 spacing={2} size={12} container>
      <Grid2 size={12}>
        <Stack flexDirection={"row"} justifyContent={"space-between"}>
          <Typography
            variant="h4"
            fontSize={16}
            fontWeight={600}
            color="secondary.contrastText"
          >
            FREQUÊNCIA DE AULAS
          </Typography>
          {/* <DateRanger
            start_date={startTime}
            end_date={endTime}
            setstart_date={(i: any) => {
              setStartTime(moment(i).toDate());
            }}
            setend_date={(i: any) => {
              setEndTime(moment(i).toDate());
            }}
          /> */}
        </Stack>
      </Grid2>
      <Grid2 size={6}>
        <Stack
          spacing={1}
          sx={{
            borderRadius: 2,
            backgroundColor: "secondary.main",
            padding: 2,
            width: "100%",
          }}
        >
          <Stack
            sx={{
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Stack>
              <Typography variant="body1">
                Total de aulas participadas
              </Typography>
              <Typography variant="body2" fontSize={24} fontWeight={700}>
                {dataClasses.totalFrequencyAll}
              </Typography>
            </Stack>
          </Stack>
        </Stack>
      </Grid2>
      <Grid2 size={6}>
        <Stack
          spacing={1}
          sx={{
            borderRadius: 2,
            backgroundColor: "secondary.main",
            padding: 2,
            width: "100%",
          }}
        >
          <Stack
            sx={{
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Stack>
              <Typography variant="body1">
                Aulas participadas no período
              </Typography>
              <Typography variant="body2" fontSize={24} fontWeight={700}>
                {dataClasses.totalFrequency}
              </Typography>
            </Stack>
          </Stack>
        </Stack>
      </Grid2>
      <Grid2 size={{ xs: 12, lg: 6 }}>
        <Stack gap={2}>
          <Typography
            variant="h4"
            fontSize={16}
            fontWeight={600}
            color="secondary.contrastText"
          >
            CALENDÁRIO DE FREQUÊNCIA
          </Typography>
          <CalendarComponent
            date={currentDate}
            markedDates={uniqueSortedDates}
            onChange={(e: any) => setCurrentDate(moment(e).toDate())}
            onMonthChange={(e: any) => {
              setStartTime(moment(e).startOf("month").toDate());
              setEndTime(moment(e).endOf("month").toDate());
            }}
          />
        </Stack>
      </Grid2>
      <Grid2
        size={{ xs: 12, lg: 6 }}
        gap={2}
        sx={{ display: "flex", flexDirection: "column" }}
      >
        <Typography
          variant="h4"
          fontSize={16}
          fontWeight={600}
          color="secondary.contrastText"
          sx={{ textTransform: "uppercase" }}
        >
          AULAS
        </Typography>
        <Empty
          data={dataClasses?.frequency?.filter((f: any) =>
            moment(currentDate).isSame(f?.classes?.date, "date")
          )}
        />
        {dataClasses?.frequency
          ?.filter((f: any) =>
            moment(currentDate).isSame(f?.classes?.date, "date")
          )
          ?.map((item: any) => (
            <Stack
              key={item.id}
              spacing={1}
              sx={{
                borderRadius: 2,
                backgroundColor: "secondary.main",
                padding: 2,
                width: "100%",
              }}
            >
              <Stack
                sx={{
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <Stack>
                  <Typography variant="body1" fontSize={14}>
                    Aula participada em{" "}
                    {moment(item.classes.date).format("DD/MM/YYYY")}
                  </Typography>
                  <Typography variant="body2" fontSize={24} fontWeight={700}>
                    {item.classes.name}
                  </Typography>
                </Stack>
              </Stack>
            </Stack>
          ))}
      </Grid2>
      <Loading loading={isFetchingClasses || isLoadingClasses} />
    </Grid2>
  );
};

export default ClassesFrequency;
